import { render, staticRenderFns } from "./InstagramDmTestDialog.vue?vue&type=template&id=5194f14b&scoped=true"
import script from "./InstagramDmTestDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./InstagramDmTestDialog.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./InstagramDmTestDialog.vue?vue&type=style&index=0&id=5194f14b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5194f14b",
  null
  
)

export default component.exports